export const ProgressData = Object.freeze({
  DateTaken: "datetaken",
  TestWindow: "testwindow",
  Test: "test",
  Score: "score",
  Performance: "performance",
});

export const PldDescriptionSources = Object.freeze({
  NotSet: "Not Set",
  ScoreMeasurePld: "Score Measure PLD",
  NominalMeasurePld: "Nominal Measure PLD",
});

export const normalizePldDescriptionSource = (value) =>
  value == null ? PldDescriptionSources.NotSet : value;
